import React from 'react'
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom'
import { useForm } from '../../hooks/useForm'
import backArrowIcon from '../../assets/img/back-arrow.png';
import "../../assets/css/common.css";
import { useAuth } from '../../routers/AuthProvider';
import { useState,useEffect } from 'react';
import { Toast } from '../../components/ToastComponent';


export default function EditUnit() {
    const { id } = useParams();
    const location = useLocation();
    const { initialData } = location.state;
    const backPath = `/unit/list`;
    const { handleInputChange, formData, submitForm, setError, setFormData, error } = useForm();

     useEffect(()=>{
                      if(error){
                         Toast.fire({
                  title: error ,
                  icon: "error",
                });
                      }
                  },[error])
    const navigate = useNavigate();
    const { user, setLoading } = useAuth();
    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        const data = {
            ...formData,
            status: 'ACTIVE',
        }
        submitForm('PUT', '/unit/' + id, data, () => {
            navigate(backPath)
        },"Successfully Updated");
    }

    const [errorMessage, setErrorMessage] = useState("");
    const [unitName, setUnitName] = useState("");

    return (
        <div className='sub-page-layout-1'>
            <Link className='back-to-page' to={backPath}>
                <img src={backArrowIcon} />
                Back
            </Link>
            <div className='container'>
                <h1 className='sub-page-title'>Edit Unit</h1>
                <div className='form-container'>
                    <form onSubmit={onSubmit} className='form flex flex-col justify-between w-full'>
                        <div className='grid grid-cols-2 gap-9'>
                            <div className='grow'>
                                <label className='x-label input-required'>Unit Name</label>
                                <input type='text'
                                    required
                                    defaultValue={initialData.unit_name}
                                    name='unit_name'
                                    pattern="[a-zA-Z]+"
                                    onChange={e => {
                                        // Show message if non-letter character is present
                                        if (/[^a-zA-Z]/.test(e.target.value)) {
                                            setErrorMessage("Only alphabetic characters are allowed.");
                                        } else {
                                            setErrorMessage(""); // Clear message when input is valid
                                        }
                                        setUnitName(e.target.value.replace(/[^a-zA-Z]/g, ""))
                                         handleInputChange({ target: { name: 'unit_name', value: e.target.value.replace(/[^a-zA-Z]/g, "") } });
                                    }}
                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    //onChange={handleInputChange}
                                    className='x-input' />
                                    {errorMessage && (
                                        <div className="text-red-500 text-sm mt-1">{errorMessage}</div>
                                    )}
                            </div>
                            <div className='grow'>
                                <label className='x-label'>Remark</label>
                                <input type='text'
                                    name='remark'
                                    defaultValue={initialData.remark}
                                    autoComplete='false'
                                    onChange={handleInputChange}
                                    className='x-input' />
                            </div>
                            <div className='grow' style={{ display: 'flex' }}>
                                <input type='checkbox'
                                    name='is_base_unit'
                                    autoComplete='false'
                                    onChange={(e) => setFormData({ ...formData, is_base_unit: e.target.checked})}

                                    defaultChecked={initialData.is_base_unit}
                                    className='x-input-checkbox' />
                                <label className='x-label-checkbox'>Base Unit</label>
                            </div>
                        </div>
                        <div className='form-btn-group'>
                           
                            <div className='flex justify-end gap-5 mt-5'>
                                <Link to={backPath} className='white-btn'>Cancel</Link>
                                <button type='submit' className='gold-btn'>Save</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}